<template>
  <div>
    <the-nav-bar :title="$t('evaluation.name')" class="nav-bar">
      <div slot="left" class="spacer row-center"></div>
    </the-nav-bar>
    <div class="body-wrapper" v-if="isLoaded">
      <div class="tips" v-if="rank === '1'">{{ $t('evaluation.reason') }}</div>
      <div class="tips" v-else>{{ $t('evaluation.hello') }}</div>
      <div class="evaluate">
        <md-radio-group class="evaluate-radio-group row" v-model="rank">
          <md-radio-box class="evaluate-radio-box" name="5">
            <svg class="icon">
              <use xlink:href="#icon-positive" />
            </svg>
            <p>{{ $t('evaluation.good') }}</p>
          </md-radio-box>
          <md-radio-box class="evaluate-radio-box" name="3">
            <svg class="icon">
              <use xlink:href="#icon-moderate" />
            </svg>
            <p>{{ $t('evaluation.mid') }}</p>
          </md-radio-box>
          <md-radio-box class="evaluate-radio-box" name="1">
            <svg class="icon">
              <use xlink:href="#icon-negative" />
            </svg>
            <p>{{ $t('evaluation.bad') }}</p>
          </md-radio-box>
        </md-radio-group>
      </div>
      <div class="negative-type" v-if="rank === '1'">
        <md-check-group
          class="negative-check-group row"
          :class="{ 'vw-55': navLang === 'en' }"
          v-model="tags"
        >
          <md-check-box
            class="negative-check-box"
            v-for="(item, i) in tagObject"
            :key="`negative-check-box-${i}`"
            :name="i"
          >
            {{ item }}
          </md-check-box>
        </md-check-group>
        <div class="input-wrapper" v-if="tags.includes('other')">
          <md-input-item
            class="negative-input"
            :placeholder="$t('evaluation.limit')"
            :maxlength="20"
            v-model.trim="remark"
          >
          </md-input-item>
        </div>
      </div>
      <div class="submit-button row">
        <md-button type="primary" @click="submit">
          <span>{{ $t('evaluation.submit') }}</span>
        </md-button>
      </div>
      <div class="help">
        <p>
          {{ $t('evaluation.assistance') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  CheckBox,
  CheckGroup,
  RadioBox,
  RadioGroup,
  InputItem,
  Button,
  Toast,
} from 'mand-mobile';
import { mapState } from 'vuex';
import postEvaluation from '@/api/post-evaluation.js';
import getTags from '@/api/get-evaluation-tags.js';
export default {
  components: {
    TheNavBar,
    [CheckBox.name]: CheckBox,
    [CheckGroup.name]: CheckGroup,
    [RadioBox.name]: RadioBox,
    [RadioGroup.name]: RadioGroup,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
  },
  data() {
    return {
      id: '',
      isLoaded: false,
      rank: '',
      tags: [],
      tagObject: {},
      remark: '',
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
    }),
  },
  mounted() {
    if (this.$route.query.id) {
      Toast.loading(this.$t('common.loading'));
      this.isLoaded = false;
      this.id = this.$route.query.id;
      getTags(this.id, this.navLang)
        .then(d => {
          if (d.data.is_eva) {
            Toast.failed(this.$t('evaluation.haveEvaluated'));
            setTimeout(() => {
              this.$router.replace(`/mine/orders/orderDetail?id=${this.id}`);
            }, 3000);
            return;
          }
          this.isLoaded = true;
          Toast.hide();
          this.tagObject = d.data.tags;
        })
        .catch(err => {
          this.isLoaded = true;
          Toast.hide();
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    }
  },
  methods: {
    submit() {
      if (this.rank === '1' && this.tags.length < 1) {
        Toast.info(this.$t('evaluation.tips'));
        return;
      }
      if (
        this.rank === '1' &&
        this.tags.includes('other') &&
        this.remark === ''
      ) {
        Toast.info(this.$t('evaluation.otherReason'));
        return;
      }
      return postEvaluation(this.id, this.rank, this.tags, this.remark)
        .then(() => {
          Toast.succeed(this.$t('evaluation.evaluateSuccess'));
          setTimeout(() => {
            this.$router.replace(`/mine/orders/orderDetail?id=${this.id}`);
          }, 3000);
        })
        .catch(err => {
          Toast.failed(`${this.$t('error.occur')}${err.message}`);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);

  .tips {
    text-align: center;
    margin: 19.2vw 4.8vw 0;
  }

  .evaluate {
    margin-top: 9.6vw;

    .evaluate-radio-group {
      margin-left: 24.27vw;
      margin-right: 24.27vw;
      justify-content: space-around;

      .evaluate-radio-box {
        border: none;

        svg {
          color: #84969C;
        }

        &.is-checked {
          svg {
            color: #2C3133;
          }

          p {
            color: #2C3133;
          }

          /deep/ .md-tag {
            display: none;
          }
        }
      }

      .icon {
        height: 6.67vw;
        width: 6.67vw;
      }

      p {
        margin-top: 2.67vw;
        text-align: center;
        color: #84969C;
      }
    }
  }

  .negative-type {
    margin-top: 9.6vw;

    .negative-check-group {
      margin-left: 9.6vw;
      margin-right: 9.6vw;
      justify-content: space-around;
    }

    .negative-check-box {
      color: #84969C;
      font-size: 2.67vw;
      border: 0.27vw solid transparent;
      border-radius: 0;
      background: #F8FBFC;

      &.is-checked {
        color: #1b6fdc;
        border: 0.27vw solid #1b6fdc;

        /deep/ .md-tag {
          display: none;
        }
      }
    }

    .vw-55 {
      margin-left: 5.5vw;
      margin-right: 5.5vw;
    }

    .input-wrapper {
      margin-top: 4.8vw;

      .negative-input {
        margin-left: 4.8vw;
        margin-right: 4.8vw;
        padding-left: 2.13vw;
        padding-right: 2.13vw;
        width: 86.14vw;
        height: 11.93vw;
        border: 0.27vw solid #C5CACC;
        border-radius: 2.57vw;
        background: #EAF1F3;
      }
    }
  }

  .submit-button {
    margin-top: 9.6vw;
    justify-content: space-around;

    .md-button {
      width: 45.2vw;
      height: 11.73vw;
    }
  }

  .help {
    position: absolute;
    bottom: 0;
    width: 100vw;

    p {
      font-size: 3.2vw;
      color: #84969C;
      text-align: center;
      margin: 2.13vw 4.8vw 4.13vw;

      span {
        color: #1b6fdc;
      }
    }
  }
}
</style>
